export const types = {
    ON_TRAINING_COMPLETED: 'ON_TRAINING_COMPLETED',
    ON_TRAINING_COMPLETED_INITIALIZE: 'ON_TRAINING_COMPLETED_INITIALIZE',
};

export const onTrainingCompletedInitialize = () => dispatch => dispatch({
    type: types.ON_TRAINING_COMPLETED_INITIALIZE,
});

export const onTrainingCompleted = () => dispatch => dispatch({
    type: types.ON_TRAINING_COMPLETED,
});



// WEBPACK FOOTER //
// ./src/actions/training.js